const template = require('../ui/templates/thumb/placeholder.hbs');

export default (function SVGPlaceholderImage () {
  return {
    getClipBox (clipId) {
      const $rect = this.$clipsData.find('#' + clipId.trim() + ' rect');
      return $rect.length === 0
        ? null
        : {
            x: parseFloat($rect.attr('x')),
            y: parseFloat($rect.attr('y')),
            width: parseFloat($rect.attr('width')),
            height: parseFloat($rect.attr('height'))
          };
    },

    render (imageId, clipId) {
      const clipBox = this.getClipBox(clipId);
      if (!clipBox) return;

      const size = clipBox.width > clipBox.height
        ? clipBox.width
        : clipBox.height;

      const renderData = {
        x: clipBox.x + (clipBox.width - size) / 2,
        y: clipBox.y + (clipBox.height - size) / 2,
        id: imageId,
        size,
        clipId,
        is_vertical: clipBox.width < clipBox.height
      };

      return {
        renderData,
        svgString: template(renderData)
      };
    },

    setClipsData (data) {
      this.$clipsData = $('<div>').html(data);
    }
  };
})();
